<template>
  <NuxtLayout name="charter-page">
    <div class="pt-4 md:pt-5 charter-destinations pb-12 mb-12">
      <LazyCharterDestinations
        class="mb-12 pb-2 md:pb-4"
        backdrop-color="white"
        prevent-price
      />
      <CountryGroupedDestinationGrid
        class="mb-12 pb-2 md:pb-5"
        :prefilled-selected-airport="selectedAirport"
        @select-airport="selectAirport($event)"
      />
      <PopularTrips class="mb-12 pb-2 md:pb-5" />
      <ParagraphWithTitle
        class="mb-2"
        title-key="charterAllTrips.findTripTitle"
      />
      <HydrateWhenVisible class="min-h-[300px] md:min-h-[100px]">
        <LazyPackageSearchBar
          key="searchbar"
          class="mb-4 p-0 border border-darkest-gray shadow-0"
          :do-search="false"
          :prefilled-selected-airport="selectedAirport"
          dropdown-direction="top"
          prevent-scroll-top
          @search="doSearch"
          @select-airport="selectAirport($event)"
        />
      </HydrateWhenVisible>
    </div>
  </NuxtLayout>
</template>

<script setup>
const charterPackagesStore = useCharterPackagesStore()
const rootStore = useRootStore()
const { urls: localeURLs } = useLocale()
const { t } = useI18n()

const { selectedAirport } = storeToRefs(charterPackagesStore)

const hardCodeOgImg = 'singlepage/destinations-solresor/e210whtkjm0tmeuvzl7y'

useHead({
  title: () => t('charterTripsHeader'),
  link: [
    {
      rel: 'canonical',
      href: () => `${localeURLs.BASE_URL}${localeURLs.destinations}/`,
    },
  ],

  meta: [
    { hid: 'author', name: 'author', content: () => t('siteTitleBrand') },
    {
      hid: 'og:url',
      property: 'og:url',
      content: () => `${localeURLs.BASE_URL}${localeURLs.destinations}/`,
    },
    {
      hid: 'og:title',
      property: 'og:title',
      content: () => `${t('charterTripsHeader')} - ${t('siteTitleBrand')}`,
    },
    {
      hid: 'og:image',
      name: 'og:image',
      content: () => formatCloudinaryImagePath(hardCodeOgImg, {
        transformation: { watermark: true },
        forceJPG: true,
        isSol: true,
      }),
    },
    {
      hid: 'og:description',
      name: 'og:description',
      content: () => t('charterTripsHeader'),
    },
    {
      hid: 'description',
      name: 'description',
      content: () => t('charterTripsHeader'),
    },
  ],
})

await useAsyncData(async () => {
  if (!isSol()) {
    return navigateTo('/')
  }

  if (!rootStore.charterAirports.length || !rootStore.charterDestinations.length) {
    await Promise.all([
      rootStore.fetchCharterAirports(),
      rootStore.fetchCharterDestinations(),
      charterPackagesStore.getDestinations(),
    ])
  }

  rootStore.SET_PAGE_BANNER({
    background: {
      picture_cloudinary: t('charterDestinations.heroImage'),
      align: '50% 55%',
    },
    type: 'CAMPAIGN',
  })
})

const doSearch = async (params) => {
  const options = await charterPackagesStore.getURLParameters(params)

  navigateTo(`${localeURLs.packagessearch}?${options}`)
}

const selectAirport = (airport) => {
  charterPackagesStore.SET_SELECTED_AIRPORT(airport)
}
</script>

<style lang="scss">
.charter-destinations {
  .charter-search {
    box-shadow: none !important;
  }
}
</style>
